
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import PinchZoom from 'pinch-zoom-js';
import * as OM from '@/model';
import { GalleryItemCreditWalletClient, PhotoPrintRequestClient, VillageGlobalGalleryItemClient } from '@/services/Services'
import store from '@/store'

@Options({})
export default class fullGalleryImageModal extends Vue {

    @Prop() item: OM.VillageGlobalGalleryItem;

    pz: PinchZoom = null;

    loaded: boolean = false;
    requested: OM.PhotoPrintRequest = null;
    showText: boolean = true;
    creditBalance: number = 0;
    alreadyBought: boolean = false;

    created(){
        this.init();
    }

    init(){
        this.loaded = false;
        Promise.all([
            PhotoPrintRequestClient.getPhotoPrintRequestExisting(this.item.identifier),
            GalleryItemCreditWalletClient.getBalanceOfUser(store.state.user.identifier, false),
            VillageGlobalGalleryItemClient.getBoughtByUser(store.state.user.identifier, false),
        ]).then(([printReq, balance, boughtItems]) => {
            this.requested = printReq;
            this.creditBalance = balance;
            this.alreadyBought = boughtItems.some(x => x.identifier === this.item.identifier);
            this.loaded = true;
        });
    }

    mounted(){
        let imgElement = this.$refs.pinch as HTMLImageElement;
        let pinchTextContainer = this.$refs.pinchTextContainer as HTMLDivElement;
        let textContainer = this.$refs.textContainer as HTMLDivElement;
        let timeout = null;
        let isHidden = false;
        imgElement.onload = (ev) => {
            this.pz = new PinchZoom(imgElement, {
                draggableUnzoomed: false,
                onZoomUpdate: onPinchUpdate,
                onDragUpdate: onPinchUpdate,
                onDoubleTap: onPinchUpdate,
            });
            setTimeout(() => {
                pinchTextContainer.style.top = imgElement.getBoundingClientRect().top + "px";
                pinchTextContainer.style.bottom = imgElement.getBoundingClientRect().bottom + "px";
                pinchTextContainer.style.height = imgElement.getBoundingClientRect().height + "px";
            })
        }
        function onPinchUpdate(target: any, event){
            if(!isHidden){
                isHidden = true;
                textContainer.style.opacity = "0";
                setTimeout(() => {
                    textContainer.style.display = "none";
                }, 200)
            }
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                if(target.zoomFactor == 1){
                    isHidden = false;
                    textContainer.style.display = "block";
                    setTimeout(() => {
                        textContainer.style.opacity = "1";
                    }, 100)
                }
            }, 600)
        }
    }
    
    beforeUnmount(): void {
        this.pz.destroy(); // Unmounts the zooming container and global event listeners
    }

    purchase(){
        VillageGlobalGalleryItemClient.purchaseGalleryItem(store.state.user.identifier, this.item.identifier)
        .then(() => {
            this.alreadyBought = true;
            this.creditBalance--;
        });
    }

    download(){
        store.state.openBrowser(this.item.original.publicUrl);
    }

    makePhotoPrintRequest(){
        this.loaded = false;
        PhotoPrintRequestClient.createPhotoPrintRequest(this.item.identifier)
        .then(x => {
            this.init();
        })
        .catch(err => {

        })
        .finally(() => {
            this.loaded = true;
        })
    }

    deleteRequest(){
        PhotoPrintRequestClient.cancelPhotoPrintRequest(this.item.identifier)
        .then(x => {
            this.init();
        })
    }
    
}

